import { createApp } from 'vue'
import App from './App.vue'
import '@fortawesome/fontawesome-free/css/all.css'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import 'vue3-video-play/dist/style.css';
import VideoPlayer from 'vue3-video-play'
import router from './router'; // 引入路由实例
import i18n from './lang';

const app = createApp(App)
app.use(ElementPlus);
app.use(router)
app.use(i18n)
app.component('VideoPlayer', VideoPlayer);
app.mount('#app')
